export default {
  text: '#21232D', // smoke.darker
  primary: '#5464CB', // indigo.base
  secondary: '#189A90', // teal.base
  error: '#EB2E2E', // rose.base
  placeholder: '#C1C4C9', // sky.dark
  background: '#FDFDFD',
  smoke: {
    darker: '#21232D',
    dark: '#414652',
    base: '#656A78',
    light: '#8C919C'
  },
  sky: {
    dark: '#C1C4C9',
    base: '#D5D7DD',
    light: '#E6E8EC',
    lighter: '#F3F4F6'
  },
  teal: {
    darker: '#06473E',
    dark: '#096D63',
    base: '#189A90',
    light: '#9DD0CC',
    lighter: '#EDF8F7'
  },
  indigo: {
    darker: '#050B40',
    dark: '#1F2D79',
    base: '#5464CB',
    light: '#B3BCF4',
    lighter: '#E2E6F9'
  },
  canary: {
    darker: '#835E00',
    dark: '#CD9B18',
    base: '#FFC93C',
    light: '#FEDA7D',
    lighter: '#FFF6DE'
  },
  rose: {
    darker: '#770000',
    dark: '#BB0000',
    base: '#EB2E2E',
    light: '#FDB6B6',
    lighter: '#FFEAEA'
  }
};
